<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>درباره ما</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>

            <div class="card card-style text-center mb-3">
                <div class="content pb-2">
                    <div>
                        <i class="far fa-check-circle color-green1-dark fa-3x pt-3 icon-size"></i>
                    </div>
                    <h3 class="font-700 mt-4 line-height-xl">اپلیکیشن برنامه ریزی و مدیریت کارهای تسکینو <span v-if="isMinVersion==true">- نسخه اشتراکی</span></h3>
                    <p class="font-12 mt-2 color-highlight mb-3">نسخه شماره {{appVersionCode}}</p>
                </div>
            </div>


            <div class="card card-style text-center mb-3" v-if="isMinVersion==false && info!=null">
                <div class="content pb-2">
                    <div>
                        <i class="far fa-user-circle color-blue1-dark fa-3x pt-3 icon-size"></i>
                    </div>
                    <h3 class="font-700 mt-4 line-height-xl">{{info.title}}</h3>
                    <p class="boxed-text-l mt-2 mb-2">
                        شمار ه تماس : {{ info.phoneNumber}}
                    </p>

                </div>
            </div>





            <div class="card card-style">
                <a href="https://dssnovinit.com/" class="text-center mt-4">
                    <img src="/assets/images/logo-shadow.png" />
                </a>


                <p class="boxed-text-l mt-2 mb-2">
                    تهران، خیابان سهروردی شمالی، خیابان میرزای زینالی شرقی، پلاک 61، واحد 7
                </p>
                <a target="_blank" :href="aboutUrl" class="text-center mt-2 font-weight-bold">
                    dssnovinit.com
                </a>
                <div class="d-flex justify-content-center align-items-center mb-5 mt-3">
                    <a href="https://t.me/taskinoapp" class="icon icon-m rounded-sm shadow-l me-1 bg-telegram mx-1"><i class="fab fa-telegram"></i></a>
                    <a href="https://www.linkedin.com/in/dssnovinit/" class="icon icon-m rounded-sm shadow-l me-1 bg-facebook mx-1"><i class="fab fa-linkedin-in"></i></a>
                    <a href="https://www.instagram.com/taskino.app" class="icon icon-m rounded-sm shadow-l me-1 bg-pink1-dark mx-1"><i class="fab fa-instagram"></i></a>
                    <a href="https://www.aparat.com/dssNovinIt" class="rounded-sm shadow-l me-1 bg-red1-dark mx-1"
                       style="display:inline-flex;justify-content:center;align-items:center;width:38px;height:38px">
                        <img src="/assets/images/aparat-icon-white.png" width="20" height="20" />
                    </a>
                    <a href="tel:02188461250" class="icon icon-m rounded-sm shadow-l me-1 bg-phone mx-1"><i class="fa fa-phone"></i></a>
                </div>
                <p class="font-16 mt-3 text-center" v-if="isMinVersion==true">
                    دسترسی به نسخه وب : https://task.dssnovinit.com
                </p>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                aboutUrl: "",
                info: null
            }
        },
        methods: {
            GetCompanyItem() {
                this.$http.get("Person/GetLocalCompany")
                   .then(data => {
                        this.info = data.data;
                    });
            },
            GetAboutLinkUrl() {
                this.$http.get("Task/GetAboutLinkUrl")
                   .then(data => {
                       this.aboutUrl = data.data;
                    });
            },
        },
        created() {
            this.GetCompanyItem();
            this.GetAboutLinkUrl();
        }
    }
</script>